
export class ShellStyleConstants {
    public static readonly MainViewClass = "mainview";
    public static readonly MainViewClassSelect = `.${ShellStyleConstants.MainViewClass}`;
    public static readonly LeftColumnClassSelect = ".left-column";
    public static readonly RightColumnClassSelect = ".right-column";
}
